import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermIdentityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_identity"}/>
}
